








































































































import {
  computed,
  defineComponent,
  Ref,
  ref,
  PropType,
} from '@vue/composition-api';
import sl from '@/serviceLocator';
import { FieldInfo, PropertyValue, PropertyVariable } from '@oare/types';

export default defineComponent({
  name: 'PropertyInfo',
  props: {
    propertyItem: {
      type: Object as PropType<PropertyVariable | PropertyValue>,
      required: true,
    },
  },
  setup(props) {
    const server = sl.get('serverProxy');
    const store = sl.get('store');
    const actions = sl.get('globalActions');

    const isEditing: Ref<Boolean> = ref(false);
    const isAdding: Ref<Boolean> = ref(false);
    const isSaving: Ref<Boolean> = ref(false);
    const newDescription: Ref<string> = ref(
      props.propertyItem.fieldInfo
        ? props.propertyItem.fieldInfo.field || ''
        : ''
    );
    const newPrimacy: Ref<number> = ref(
      props.propertyItem.fieldInfo
        ? props.propertyItem.fieldInfo.primacy || 0
        : 0
    );
    const newLanguage: Ref<string> = ref(
      props.propertyItem.fieldInfo
        ? props.propertyItem.fieldInfo.language || 'n/a'
        : 'n/a'
    );
    const reactiveFieldUuid: Ref<string> = ref(
      props.propertyItem.fieldInfo
        ? props.propertyItem.fieldInfo.uuid || ''
        : ''
    );

    const closeInput = () => {
      isEditing.value = false;
      isAdding.value = false;
      isSaving.value = false;
    };

    const saveEdit = async () => {
      if (reactiveFieldUuid.value) {
        isSaving.value = true;
        try {
          await server.updatePropertyDescriptionField({
            uuid: reactiveFieldUuid.value,
            description: newDescription.value,
            primacy: newPrimacy.value,
            location: 'taxonomyTree',
          });

          await assignNewValues();
          actions.showSnackbar('Successfully updated description');
        } catch (err) {
          actions.showErrorSnackbar(
            'Failed to update description',
            err as Error
          );
        } finally {
          closeInput();
        }
      }
    };

    const addDescription = async () => {
      try {
        isSaving.value = true;
        await server.createNewPropertyDescriptionField({
          referenceUuid: props.propertyItem.uuid,
          description: newDescription.value,
          primacy: newPrimacy.value,
        });

        await assignNewValues();
        actions.showSnackbar('Successfully added new description');
      } catch (err) {
        actions.showErrorSnackbar(
          'Failed to add new description',
          err as Error
        );
      } finally {
        closeInput();
      }
    };

    const assignNewValues = async () => {
      const newProps: FieldInfo = await server.getFieldInfo(
        props.propertyItem.uuid
      );
      newDescription.value = newProps.field ?? 'none';
      newPrimacy.value = newProps.primacy ?? 0;
      newLanguage.value =
        newProps.language === 'default'
          ? 'English'
          : newProps.language || 'n/a';
      reactiveFieldUuid.value = newProps.uuid ?? '';
    };

    const canSubmit = computed(
      () =>
        newDescription.value !== 'none' &&
        newPrimacy.value !== 0 &&
        newDescription.value !== ''
    );

    const canView2 = computed(() =>
      store.hasPermission('VIEW_FIELD_DESCRIPTION')
    );

    const canAddEdit1 = computed(() =>
      store.hasPermission('ADD_EDIT_FIELD_DESCRIPTION')
    );

    const isAdmin = computed(() => store.getters.isAdmin);

    return {
      isEditing,
      isAdding,
      isSaving,
      saveEdit,
      closeInput,
      newDescription,
      addDescription,
      newLanguage,
      newPrimacy,
      canSubmit,
      reactiveFieldUuid,
      isAdmin,
      canView2,
      canAddEdit1,
    };
  },
});
